import React from "react";
import { useTranslation } from "react-i18next";
import { TimeUnit } from "components/common";
const DATABASE_TYPES = {
  MAXMIND_ASN: "maxmind_adapter.database_types.asn",
  MAXMIND_CITY: "maxmind_adapter.database_types.city",
  MAXMIND_COUNTRY: "maxmind_adapter.database_types.country",
  IPINFO_STANDARD_LOCATION: "maxmind_adapter.database_types.ipinfo_location",
  IPINFO_ASN: "maxmind_adapter.database_types.ipinfo_asn"
};
const MaxmindAdapterSummary = ({ dataAdapter: { config } }) => {
  const { t } = useTranslation("common");
  const databaseTypeKey = DATABASE_TYPES[config.database_type];
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, t("maxmind_adapter.summary.database_file_path")), /* @__PURE__ */ React.createElement("dd", null, config.path), /* @__PURE__ */ React.createElement("dt", null, t("maxmind_adapter.summary.database_type")), /* @__PURE__ */ React.createElement("dd", null, databaseTypeKey ? t(databaseTypeKey) : null), /* @__PURE__ */ React.createElement("dt", null, t("maxmind_adapter.summary.check_interval")), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(TimeUnit, { value: config.check_interval, unit: config.check_interval_unit })));
};
export default MaxmindAdapterSummary;
